import type { IssueDefinition } from "../../issue-definition";
import { ISSUE_CATEGORY } from "../../issue-enums";

/**
 * The tenant's git-host node is down, disconnected, ineligible, or failing its
 * EC2 status checks past the node health policy's threshold.
 *
 * Its own code, and critical, because the node is one of one: every push, every
 * build job's source fetch and every repository read of the tenant goes through
 * it, and there is nothing to fail over to. It is never replaced — its volume
 * holds the repositories — so the remedy is a reboot, not the client pool's
 * replacement.
 */
export const VIBE_TENANT_GIT_HOST_NODE_UNHEALTHY = {
  category: ISSUE_CATEGORY.OBSERVABILITY,
  message:
    "This tenant's git-host node has been unhealthy past the node-health threshold: down or disconnected in Nomad, marked ineligible, or failing an EC2 status check. The git host is a single node holding every repository of the tenant, so pushes and every build job's source fetch are failing or about to. The payload names the node, its instance, the cause and since when.",
  severity: "critical",
  // Pages: the git host is one node holding the tenant's repositories, so its
  // loss stops every build and every push the moment it happens.
  page: true,
  remedy:
    "Where the tenant's `vibe_githost_auto_reboot` flag is on, the node-health sweep reboots a git host Nomad has written off while EC2 reports it running — check the sweep's cron output for the reboot or the guardrail that refused it. With the flag off, reboot it by hand (`aws ec2 reboot-instances --instance-ids <id>`): the repository volume stays attached and the node's boot units remount it and restart Forgejo. Never terminate it and never mark it Unhealthy — a replacement is a volume hand-off, not a reboot. A failing EC2 status check that a reboot does not clear is an AWS hardware fault; stop and start the instance to move it to new hardware. This clears on its own once the node is no longer a finding."
} as const satisfies IssueDefinition;
